const helpPage = {
  "help.faq.title": "Preguntas frecuentes",
  "help.faq.description": "Aquí puedes encontrar respuestas a todas las preguntas frecuentes",
  "help.contact.title": "Contacto",
  "help.contact.description": "Envía una solicitud a nuestro equipo de soporte",
};

export const help = {
  ...helpPage,
};